import { render, staticRenderFns } from "./technology-detail.vue?vue&type=template&id=77a8a3c0&scoped=true&"
import script from "./technology-detail.vue?vue&type=script&lang=js&"
export * from "./technology-detail.vue?vue&type=script&lang=js&"
import style0 from "./technology-detail.vue?vue&type=style&index=0&id=77a8a3c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a8a3c0",
  null
  
)

export default component.exports